import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormGroup } from '@shared/ui/forms/display';
import TabsComponent from '@shared/ui/TabsComponent';

export default function CurrencyTabs({ control, name, label }) {
  const { t } = useTranslation();

  const options = [
    { label: t('any_currency'), value: null, icon: 'any-outline' },
    { label: 'USD', value: 'USD', icon: 'usd' },
    { label: 'EUR', value: 'EUR', icon: 'eur' },
  ];

  return (
    <FormGroup label={label}>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <TabsComponent
            fullWidth
            isGroup
            value={field.value}
            setValue={field.onChange}
            options={options}
          />
        )}
      />
    </FormGroup>
  );
}
